/** Private Mac beta copy. Does not bypass macOS checks. */

const APPLE_VERIFY_HELP = "https://support.apple.com/en-us/102445";

function escapeHtml(value) {
  return String(value ?? "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;");
}

function requireFormat(format) {
  const kind = String(format ?? "").trim().toLowerCase();
  if (kind !== "zip" && kind !== "dmg") {
    throw new Error("format must be zip or dmg");
  }
  return kind;
}

/** Short notice for placement beside a Mac download control. */
export function macDownloadNotice() {
  return [
    '<aside class="mac-download-notice" role="note">',
    "<p><strong>Private Mac beta.</strong> The release pipeline requires Developer ID signing and Apple notarization before publishing.</p>",
    "</aside>",
  ].join("");
}

function installSteps(kind) {
  if (kind === "zip") {
    return [
      "Download the ZIP and extract the app.",
      "Move the app into the Applications folder.",
      "Open the app from Applications.",
    ];
  }
  return [
    "Open the disk image.",
    "Drag the app into the Applications folder.",
    "Open the app from Applications.",
  ];
}

/**
 * Numbered install steps plus refusal guidance.
 * @param {{version?: string, format: "zip"|"dmg"}} options
 */
export function macInstallGuide({ version, format } = {}) {
  const kind = requireFormat(format);
  const safeVersion = escapeHtml(version).trim();
  const label = kind === "zip" ? "ZIP" : "disk image";
  const heading = safeVersion ? `Install version ${safeVersion}` : "Install the Mac app";
  const items = installSteps(kind).map((step) => `<li>${step}</li>`).join("");

  return [
    '<section class="mac-install-guide" aria-labelledby="mac-install-heading">',
    `<h2 id="mac-install-heading">${heading}</h2>`,
    `<p>Open the ${label} and follow these steps. macOS manages capture and microphone permissions separately.</p>`,
    `<ol>${items}</ol>`,
    "<h3>If macOS refuses the app</h3>",
    `<p>If macOS reports a problem, stop and review Apple’s guidance: <a href="${APPLE_VERIFY_HELP}">Safely open apps on your Mac</a>.</p>`,
    "<p>Stop if the message says the app is malware, is damaged, or was revoked. Do not continue. Request a review of the download.</p>",
    "<p>A person may need to consent on this Mac before the app opens.</p>",
    "</section>",
  ].join("");
}
